import { useSelector } from "react-redux";
// import FeedCard from "../Feeds/FeedCard";
// Adjust if you have a single-card version
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { deleteFeed, getExplore, getMyFeeds, updateFeed } from "../../../../Redux/Reducers/communityReducer";
import FeedPostSkeleton from "../../../LoadingSkeleton/Events/FeedPostSkeleton";
import FeedIcon from "../../../..//Assets/css/Community/FeedIcon.webp";
import { Box, Typography } from "@mui/material";
import EventCard from "../Events/EventCard";
import FeedCard from "../Feeds/FeedCard";
import PostFeedModal from "../Components/PostFeedModal";


const ExploreFeeds = () => {
  const dispatch = useDispatch();
  const exploreAllFeeds = useSelector((state) => state?.community?.exploreAllFeeds?.data);
  const nextPagemeta = useSelector((state) => state?.community?.exploreAllFeeds?.meta);
  const loading = useSelector((state) => state?.community?.exploreAllFeeds?.loading); // Adjust if you have a loading flag
  const [hasMore, setHasMore] = useState(true);
  const loaderRef = useRef();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editFeed, setEditFeed] = useState(null);
  const exploreType = useSelector((state) => state?.community?.exploreType);

  // console.log("exploreAllFeeds+++", exploreAllFeeds)
  
  useEffect(()=>{
    dispatch(getExplore( {type: exploreType }));
  },[])
  
  
  useEffect(() => {
    if (nextPagemeta?.nextCursor === null || nextPagemeta?.nextCursor === undefined) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }, [nextPagemeta]);

useEffect(() => {
  if (!loaderRef.current) return;
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && hasMore && !loading) {
        if (nextPagemeta?.nextCursor) {
          dispatch(getExplore({ cursor: nextPagemeta?.nextCursor, type: exploreType}));
        }
      }
    },
    { rootMargin: "200px" }
  );
  observer.observe(loaderRef.current);
  return () => observer.disconnect();
}, [hasMore, loading, nextPagemeta, dispatch]);;

  const handleEdit = (item) => {
    setEditFeed(item);
    setEditModalOpen(true);
  };

     // Delete handler
    const handleDelete = async (item) => {
      const res = await dispatch(deleteFeed(item.id));
      if (res?.payload?.statusCode === 200) {
        await dispatch(getMyFeeds({ type: exploreType }));
      }
    };

      // Update handler for modal
     const handleUpdatePost = async (updatedContent, updatedMedia) => {
        const payload = new FormData();
        payload.append("content", updatedContent);
        payload.append("is_visible", true);
        updatedMedia.forEach((mediaItem) => {
          if (mediaItem.file) {
            payload.append("media", mediaItem.file);
          } else {
            payload.append("existing_media", mediaItem.preview || mediaItem.url);
          }
        });
        const res = await dispatch(updateFeed({ id: editFeed.id, data: payload }));
        if (res?.payload?.statusCode === 200) {
          await dispatch(getMyFeeds({ type: exploreType }));
        }
        setEditModalOpen(false);
        setEditFeed(null);
      };


  return (
    <div >
    {!loading && (!exploreAllFeeds || exploreAllFeeds?.length === 0) ? (
      <Box sx={{ textAlign: "center",height: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <img
            src={FeedIcon} // You can use a placeholder image or custom illustration
            alt="No Posts Found"
            style={{ width: 80, marginBottom: 16 , opacity: 0.8 }}
          />
          <Typography variant="h6" sx={{fontSize:"14px"}}>
            No Posts Found
          </Typography>
        </Box>
    ) : (
      <div >
        {exploreAllFeeds?.map((item) => {
          if (item.type === "post") {
            return (
              <FeedCard
                key={item?.id}
                item={item}
                is_my_post={true}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            );
          }
          if (item.type === "event") {
            return <EventCard key={item?.id} event={item} />;
          }
          return null;
        })}

        {/* Loader div for IntersectionObserver */}
        <div ref={loaderRef} style={{ height: 1 }} />
        {loading && (
          <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
            <FeedPostSkeleton />
          </div>
        )}
        {!hasMore && exploreAllFeeds?.length > 0 && (
          <div style={{ textAlign: "center", margin: 16, color: "#888" }}>
            You've reached the end of the feed
          </div>
        )}
      </div>
    )}

    {editModalOpen && (
      <PostFeedModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        initialContent={editFeed?.content}
        initialMedia={editFeed?.media}
        onSubmit={handleUpdatePost}
        isEditMode={true}
        postId={editFeed?.id}
        author={editFeed?.author}
      />
    )}
  </div>
  );
};

export default ExploreFeeds;